import * as React from 'react';

import CaretBadge16 from './CaretBadge16';

export const caretBadge16 = () => <CaretBadge16 />;

export default {
    title: 'Icon/Fill/CaretBadge16',
    component: CaretBadge16,
    parameters: {
        notes: "`import CaretBadge16 from 'box-ui-elements/es/icon/fill/CaretBadge16';`",
    },
};
